import React from "react";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";
// @material-ui/icons

// core components
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

import projectCardStyle from "../../../assets/jss/components/projectCardStyle";
import Badge from "../../../components/Badge/Badge";
import Muted from "../../../components/Typography/Muted";
import CardFooter from "../../../components/Card/CardFooter";
import {Link} from "react-router-dom";

class ProjectCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDescription: false,
        }
    }

    onMouseEnter() {
        if (!this.state.showDescription) {
            this.setState({showDescription: true})
        }
    }

    onMouseExit() {
        if (this.state.showDescription) {
            this.setState({showDescription: false})
        }
    }

    render() {
        const {classes, item, simpleView} = this.props;
        return (
            <Link to={"/projects/" + item.id}>
                <Card className={classes.card} key={item.name} onMouseEnter={() => this.onMouseEnter()}
                      onMouseLeave={() => this.onMouseExit()}>
                    {item.image ?
                        <div>
                            <div className={classes.imgCard} style={{backgroundImage: "url(" + (item.image) + ')'}}>
                                {this.renderDescription(this.getTagline(item), classes.description)}
                            </div>
                            <CardBody className={classes.cardBody}>
                                <h2>
                                    {item.name}
                                </h2>
                                <p>
                                    <b>{item.role}</b>
                                </p>
                            </CardBody>
                        </div> :
                        <CardBody className={classes.cardBody}>


                            <h2>
                                {item.name}
                            </h2>
                            <p>
                                <b>{item.role}</b>
                            </p>
                            <Muted>{this.getTagline(item)}</Muted>
                        </CardBody>
                    }

                    <CardFooter>
                        <div>
                            {item.tags.map(item => <Badge style={{backgroundColor: item.color}}
                                                          key={item.name}>{item.name}</Badge>)}
                        </div>
                    </CardFooter>
                </Card>
            </Link>
        )
    }

    getTagline(item) {
        return item.tagline ? item.tagline : item.description;
    }

    renderDescription(item, className) {
        if (this.state.showDescription) {
            return <CardBody className={className}>
                <h4>{item}</h4>
            </CardBody>;
        }
    }
}

ProjectCard.defaultProps = {
    simpleView: false,
};

export default withStyles(projectCardStyle)(ProjectCard);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Components/ProjectCard.jsx